enum ApiConstants {
    UPDATE_USER_DETAILS = "/api/signup/updateUserPreferences",
    CREATE_ACCOUNT = "/api/signup/createAccount",
    FORGOT_PASSWORD = "/api/forgotPassword",
    RESET_PASSWORD = "/api/resetPassword",
    UPDATE_PASSWORD = "/api/updatePassword",
    VALIDATE_RESET_PASSWORD_TOKEN = "/api/validatePasswordResetToken/",
    GET_CONFIGS = "/api/getConfigs/",
    CREATE_ORDER_SALE = "/api/order/sale",
    GET_HOSTED_PAGES = "/api/pay/hostedPages",
    CUSTOMER_CARDS = "/api/pay/customers/:fdCustomerId/cards",
    CUSTOMER_CARD_SINGLE = "/api/pay/customers/:fdCustomerId/cards/:fdAccountId",
    CUSTOMER_ADD_FUNDS = "/api/pay/customers/add/funds",
    CUSTOMER_VAULT_CARD = "/api/pay/customers/vaultCard",
    CUSTOMER_AUTO_RELOAD_FUNDS = "/api/pay/customers/autoReloadFunds",
    GIFT_CARD_CONTENT = "/api/giftcard/content/",
    GIFT_CARD_CHECK_BALANCE = "/api/giftcard/checkbalance/",
    GIFT_CARD_TRANSFER = "/api/giftcard/transfer",
    UNSUBSCIBE = "/api/unsubscribe",
    STORE_AVALABILITY = "api/availability",
    ORDER_SCHEDULE_GUEST = '/api/order/schedule/guest',
    ORDER_SCHEDULE_LOYALTY = '/api/order/schedule/loyalty',
    PENDING_ORDERS = "/api/orders/pending",
    UPSELL_PRODUCTS = "/api/upsell/products",
    RECEIPT_VISIT_CODE = "/api/visitCode",
}

export default ApiConstants;
